import { render, staticRenderFns } from "./show-items.vue?vue&type=template&id=4b6b3b00&"
import script from "./show-items.vue?vue&type=script&lang=js&"
export * from "./show-items.vue?vue&type=script&lang=js&"
import style0 from "./show-items.vue?vue&type=style&index=0&id=4b6b3b00&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b6b3b00')) {
      api.createRecord('4b6b3b00', component.options)
    } else {
      api.reload('4b6b3b00', component.options)
    }
    module.hot.accept("./show-items.vue?vue&type=template&id=4b6b3b00&", function () {
      api.rerender('4b6b3b00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/show-items.vue"
export default component.exports